module.exports = __webpack_public_path__ + "img/1-gjpI_3Ku5RLXcAiQVe_xngrea2XDrvt.c0ea50be.png";